import React, { useEffect, useState } from 'react';
import { DeleteButtonWrapper, SubmitButton, SuccessWrapper } from 'components/Button/Button.styles';
import { ButtonColumn, ButtonRowWrapper } from './FormComponents/Form.styles';
import Button from 'components/Button/Button';
import Column from "components/Grid/Column";
import Row from "components/Grid/Row";
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import FuzzySearchSelect from 'components/FuzzySearch/FuzzySearchSelect';
import TextField from './FormComponents/TextField';
import Form from './FormComponents/Form';
import CutUpdatedForm from "./CutUpdatedForm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DateField from "./FormComponents/DateField";
import ArrayField from "./FormComponents/ArrayField";
import AddClientForm from "./AddClientForm";
import DeleteProjectForm from './DeleteProjectForm';
import useModal from 'components/Modal/useModal';
import TableModal from 'components/Table/TableModal';
import AddForemanForm from './AddForemanForm';
import LoadingOverlay from "../Layout/MapView/LoadingOverlay/LoadingOverlay";
import prettyPhone from 'utility/prettyPhone';

import isEmpty from 'lodash.isempty';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { isAdmin } from "utility/Authorization/roleUtils";
import { findProjectDuplicate } from "utility/projectDuplicates";
import { stripMeasurementsFromSpecialCuts } from "utility/cutMeasurements";
import { applyCutSurfaces } from "utility/productSurfaces";

function ProjectForm({id}) {
    const api = useDavidApi();

    const cutInitialState = {
        steps: [],
        product: '',
        subClient: null,
        street: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        comments: '',
        monoCurb: null,
        curb: null,
        driveway: null,
        sidewalk: null,
        flowableFill: null,
        originalLengthFeet: '',
        originalLengthInches: '',
        originalWidthFeet: '',
        originalWidthInches: '',
        originalDepthFeet: '',
        originalDepthInches: '',
        actualLengthFeet: '',
        actualLengthInches: '',
        actualWidthFeet: '',
        actualWidthInches: '',
        actualDepthFeet: '',
        actualDepthInches: '',
        latitude: 37.977432,
        longitude: -87.544054,
        specials: []
    };
    const inputsInitialState = {
        orderDate: '',
        workOrderNumber: '',
        excavationNumber: '',
        client: {id: ''},
        foreman: {id: ''},
        cuts: [{
            steps: [],
            product: '',
            subClient: null,
            street: '',
            address: '',
            city: '',
            state: '',
            zipcode: '',
            comments: '',
            monoCurb: null,
            curb: null,
            driveway: null,
            sidewalk: null,
            flowableFill: null,
            originalLengthFeet: '',
            originalLengthInches: '',
            originalWidthFeet: '',
            originalWidthInches: '',
            originalDepthFeet: '',
            originalDepthInches: '',
            actualLengthFeet: '',
            actualLengthInches: '',
            actualWidthFeet: '',
            actualWidthInches: '',
            actualDepthFeet: '',
            actualDepthInches: '',
            latitude: 37.977432,
            longitude: -87.544054,
            specials: []
        }]
    };

    const [inputs, setInputs] = useState(inputsInitialState);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [foremanPhone, setForemanPhone] = useState('');
    const [clientsLoading, setClientsLoading] = useState(true);
    const [foremenLoading, setForemenLoading] = useState(true);
    const [clientFuzzySearchSelectItems, setClientFuzzySearchSelectItems] = useState({});
    const [foremanFuzzySearchSelectItems, setForemanFuzzySearchSelectItems] = useState({});
    const [newCut, setNewCut] = useState({});
    const [newSuccessMessage, setNewSuccessMessage] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [profileLoading, setProfileLoading] = useState(true);
    const [projectDeleted, setProjectDeleted] = useState(false);
    const navigate = useNavigate();
    const deleteProjectModal = useModal();
    const [deleteProjectModalClient, setDeleteProjectModalClient] = useState(null);
    const duplicateModal = useModal();
    const [duplicateInfo, setDuplicateInfo] = useState(null);

    const isEditForm = Boolean(id);

    useEffect(() => {
        if (api.profile !== null) {
            setProfileLoading(false);
            return;
        }

        setProfileLoading(true);
        api.getProfile();
    }, [api.profile]);

    useEffect(() => {
        if (id === null || id === undefined) {
            return;
        }

        (async () => {
            setLoading(true);
            const project = await api.getProject(id);
            setInputs(project);
            setLoading(false);

            setNewSuccessMessage(
                <SuccessWrapper>
                    <div>Your changes were processed successfully.</div>
                </SuccessWrapper>
            );
        })();
    }, [id]);

    useEffect(() => {

        if (api.clients !== null) {
            setClientsLoading(false);

            setClientFuzzySearchSelectItems(api.clients?.map(client => ({
                label: client?.name,
                value: {id: client?.id},
                id: client?.id,
            })));
            return;
        }

        setClientsLoading(true);
        api.getClients();
    }, [api.clients]);

    useEffect(() => {
        if (api.foremen !== null) {
            setForemenLoading(false);
            return;
        }

        setForemenLoading(true);
        api.getForemen();
    }, [api.foremen]);

    useEffect(() => {
        if (foremenLoading || isEmpty(api.foremenByUri)) {
            return;
        }

        const prevForemanId = inputs?.foreman?.id;
        const clientId = inputs?.client?.id;

        if (!clientId) {
            setForemanFuzzySearchSelectItems([]);
            setInputs({
                ...inputs,
                foreman: null,
            });
            return;
        }

        const clientForemen = api.clientsById?.[clientId]?.foremen?.map(uri => api.foremenByUri?.[uri]);

        if (!clientForemen?.length) {
            setForemanFuzzySearchSelectItems([]);

            setInputs({
                ...inputs,
                foreman: null,
            });

            return;
        }

        const newForemanFuzzySearchSelectItems = [];
        let prevForemanExistsInThisClient = false;

        for (const foreman of clientForemen) {
            newForemanFuzzySearchSelectItems.push({
                label: foreman?.name,
                value: { id: foreman?.id },
                id: foreman?.id,
            });

            if ( prevForemanId === foreman?.id ) {
                prevForemanExistsInThisClient = true;
            }
        }

        setForemanFuzzySearchSelectItems(newForemanFuzzySearchSelectItems);

        setErrors(current => {
            const {foreman, ...rest} = current;
            return rest;
        });

        if (!prevForemanExistsInThisClient) {
            setInputs({
                ...inputs,
                foreman: null,
            });
        }
    }, [inputs.client, api.foremenByUri, api.clients]);

    useEffect(() => {
        if ( inputs?.foreman && !isEmpty(api?.foremenById) ) {
            const match = api.foremenById?.[inputs?.foreman?.id];

            if (match?.phone) {
                setForemanPhone(match.phone);
                return;
            }
        }

        setForemanPhone('');
    }, [inputs.foreman, api.foremenById]);

    useEffect(() => {
        if (newCut.id !== undefined) {
            navigate("/projects/" + newCut.id + "/edit");
        }
    }, [newCut]);

    const scrollTop = () => {
        window.scrollTo({ top:0, behavior: 'smooth' });
    }

    // New cuts are usually at (or near) the same place as the first one, so seed the
    // location fields — and the subclient, when set — from the first cut. Everything
    // else (product, measurements, steps, specials) starts blank.
    const buildCutPrototype = () => {
        const firstCut = inputs?.cuts?.[0];

        if (!firstCut) {
            return { ...cutInitialState, steps: [], specials: [] };
        }

        return {
            ...cutInitialState,
            steps: [],
            specials: [],
            street: firstCut.street ?? cutInitialState.street,
            address: firstCut.address ?? cutInitialState.address,
            city: firstCut.city ?? cutInitialState.city,
            state: firstCut.state ?? cutInitialState.state,
            zipcode: firstCut.zipcode ?? cutInitialState.zipcode,
            latitude: firstCut.latitude ?? cutInitialState.latitude,
            longitude: firstCut.longitude ?? cutInitialState.longitude,
            subClient: firstCut.subClient ?? null,
        };
    }

    const deleteProjectModalTriggerHandler = (id) => {
        setDeleteProjectModalClient(id);
        deleteProjectModal.show();
    }

    const submitHandler = async (values) => {
        setFormSubmitted(true);
        setLoading(true);

        // Special cuts capture additional work, not dimensions — drop any measurements
        // before saving so they're never persisted on a Special cut. Then rewrite each
        // cut's product selection into the `surface` string the API expects on write.
        const cleanedValues = applyCutSurfaces(stripMeasurementsFromSpecialCuts(values));

        // An empty excavation number should be stored as null rather than "".
        if (cleanedValues.excavationNumber === undefined
            || cleanedValues.excavationNumber === null
            || String(cleanedValues.excavationNumber).trim() === '') {
            cleanedValues.excavationNumber = null;
        }

        if (!id) {
            // Duplicate check (server-side): same work order number + a cut at the same
            // street/address as an existing project. If matched, alert and do not save.
            const duplicate = await findProjectDuplicate(cleanedValues, api.checkProjectDuplicate);

            if (duplicate) {
                setLoading(false);
                setFormSubmitted(false);
                scrollTop();
                setDuplicateInfo({
                    workOrderNumber: cleanedValues.workOrderNumber,
                    address: duplicate.address,
                    projects: duplicate.projects ?? [],
                });
                duplicateModal.show();
                return;
            }

            const response = await api.postProject(cleanedValues);
            setNewCut(response);
            setNewSuccessMessage(
                <SuccessWrapper>
                    <div>Your project has been added. Updating...</div>
                    <FontAwesomeIcon icon={regular('spinner-third')} style={{fontSize: '24px'}} className="fa-spin fa-4x" />
                </SuccessWrapper>
            );
        } else {
            const response = await api.putProject(cleanedValues);
            setNewCut(response);
            setNewSuccessMessage(
                <SuccessWrapper>
                    <div>Your changes were processed successfully.</div>
                </SuccessWrapper>
            );
        }

        scrollTop();
        setLoading(false);
        setFormSubmitted(false);
    }

    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/project/create"){
            setInputs(inputsInitialState);
            setNewSuccessMessage("");
            setProjectDeleted(null);
        }
    }, [location.pathname]);

    return (
        <>
            {(loading) && (clientsLoading || foremenLoading || (isEditForm && !inputs?.client)) && (
                <LoadingOverlay isLighter />
            )}

            {loading && formSubmitted && (
                <LoadingOverlay isLighter>
                    <h3>
                        {isEditForm ? "Project updated! Redirecting..." : "Project created! Redirecting..."}
                    </h3>
                </LoadingOverlay>
            )}

            {isEditForm ? (
                <h2>Edit Project</h2>
            ) : (
                <h2>Add New Project</h2>
            )}

            <div>
                <TableModal title="Delete Project" isShowing={deleteProjectModal.isShowing} hide={deleteProjectModal.hide}>
                        <DeleteProjectForm
                            id={deleteProjectModalClient}
                            hideModal={deleteProjectModal.hide}
                            onDelete={() => {
                                setProjectDeleted(true);
                                scrollTop();
                            }}
                        />
                </TableModal>

                <TableModal title="Possible Duplicate Project" isShowing={duplicateModal.isShowing} hide={duplicateModal.hide}>
                    <div>
                        <p>
                            Work Order #{duplicateInfo?.workOrderNumber} already exists with a cut
                            at {duplicateInfo?.address}. The project was not saved.
                        </p>

                        {duplicateInfo?.projects?.length > 0 && (
                            <>
                                <p>View and edit the existing project{duplicateInfo.projects.length > 1 ? 's' : ''}:</p>
                                <ul>
                                    {duplicateInfo.projects.map((projectIri) => {
                                        const projectId = projectIri.split('/').pop();

                                        return (
                                            <li key={projectIri}>
                                                <Link
                                                    to={`/projects/${projectId}/edit`}
                                                    onClick={duplicateModal.hide}
                                                >
                                                    Edit Project #{projectId}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </>
                        )}
                    </div>
                </TableModal>
            </div>

            {(projectDeleted && isEditForm) ? (
                <Row gutter={0}>
                    <SuccessWrapper style={{ backgroundColor: '#f7fbf8', border:'1px solid #188429', borderRadius: '5px', padding: '8px', display: 'flex', width: '100%', color: '#188429', marginTop: '15px'}}>
                        <div>The project was deleted successfully.</div>
                    </SuccessWrapper>
                </Row>
            ) : (
                <Row gutter={0}>
                    <Form
                        id={id}
                        successMessage={newSuccessMessage}
                        values={inputs}
                        setValues={setInputs}
                        errors={errors}
                        setErrors={setErrors}
                        asyncSubmitHandler={(values) => submitHandler(values)}
                    >
                        <Row gutter={15}>
                            <Column width={1/3}>
                                <DateField
                                    label="Order Date"
                                    name="orderDate"
                                    value={inputs.orderDate}
                                    required
                                />
                            </Column>
                            <Column width={1/3}>
                                <TextField
                                    label="Work Order/SAP Number"
                                    name="workOrderNumber"
                                />
                            </Column>
                            <Column width={1/3}>
                                <TextField
                                    label="Excavation Number"
                                    name="excavationNumber"
                                />
                            </Column>
                        </Row>
                        <Row gutter={15}>
                            <Column width={1/3}>
                                <FuzzySearchSelect
                                    label="Client"
                                    name="client"
                                    placeholder="Select One..."
                                    items={clientFuzzySearchSelectItems}
                                    addChoiceButtonLabel="Add Client"
                                    addChoiceForm={AddClientForm}
                                    required
                                />
                            </Column>
                            <Column width={1/3}>
                                <FuzzySearchSelect
                                    label="Company Foreman"
                                    name="foreman"
                                    placeholder={!inputs?.client ? `Please select a client.` : `Select One...`}
                                    items={foremanFuzzySearchSelectItems}
                                    addChoiceButtonLabel="Add Foreman"
                                    addChoiceForm={AddForemanForm}
                                    readOnly={!inputs?.client}
                                />
                            </Column>
                            <Column width={1/3}>
                                <TextField
                                    label="Foreman Phone Number"
                                    name="foremanPhone"
                                    placeholder="Please select a foreman."
                                    value={prettyPhone(foremanPhone)}
                                    readOnly
                                />
                            </Column>
                        </Row>

                        <hr />

                        <ArrayField
                            name="cuts"
                            label="Add Cuts"
                            entryLabelSingular="Cut"
                            entryComponent={<CutUpdatedForm cutInitialState={cutInitialState} />}
                            prototypeValue={buildCutPrototype}
                        />
                        <ButtonRowWrapper>
                            <ButtonColumn>
                                <SubmitButton style={{marginTop:'15px'}}>Submit</SubmitButton>
                            </ButtonColumn>

                            {isEditForm && !profileLoading && isAdmin(api.profile) && (
                                <ButtonColumn>
                                    <DeleteButtonWrapper>
                                        <Button
                                            iconLeft={<FontAwesomeIcon icon={solid('trash')} />}
                                            style={{marginTop:'15px'}}
                                            onClick={() => deleteProjectModalTriggerHandler(id)}
                                        >
                                            Delete
                                        </Button>
                                    </DeleteButtonWrapper>
                                </ButtonColumn>
                            )}
                        </ButtonRowWrapper>
                    </Form>
                </Row>
            )}
        </>
    )
  }

export default ProjectForm;
